module.exports = __webpack_public_path__ + "img/心智宝大使.0701ec6c.jpg";